import Bugsnag from '@bugsnag/js';
import type { Client, Config } from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import bugsnagOnErrorCallback from '@web/utils/bugsnagOnErrorCallback';

type StartBugsnagOptions = Pick<Config, 'user' | 'metadata'>;

function startBugsnag(options: StartBugsnagOptions = {}): Client {
  return Bugsnag.start({
    apiKey: window.Clearstream.global.keys.bugsnag,
    releaseStage: window.Clearstream.global.env ?? 'unknown',
    appVersion: window.Clearstream.global.appVersion,
    onError: bugsnagOnErrorCallback,
    plugins: [new BugsnagPluginVue()],
    ...options,
  });
}

export default startBugsnag;
